/**
 * Frontend ">=" and "<=" Operators.
 *
 * Registers with the module registry to handle the inclusive comparison
 * operators. Each is evaluated as GF's native exclusive comparison OR'd with
 * GF's native `is` check, mirroring the PHP evaluation and keeping DOM value
 * reading consistent with GF's own logic.
 *
 * @package
 */

import { registerModule } from './module-registry';
import { matchesConditionalOperation } from './conditional-operation';

registerModule({
	slug: 'operator-greater-less-equal',
	handles: (rule) => rule.operator === '>=' || rule.operator === '<=',
	evaluate: (_isMatch, formId, rule) =>
		matchesConditionalOperation(rule.operator, (operator) =>
			gf_is_match(formId, {
				fieldId: rule.fieldId,
				operator,
				value: rule.value,
			})
		),
});
